a[slot='logo'] {
    width: 83px;
    height: 40px;
    display: block;

    svg {
        width: 100%;
        height: auto;

        .claim {
            display: none;
        }
    }

    &.swiss {
        width: 56px;
        height: 57px;

        svg {
            transform: scale(2.1) translate3d(0, 0, 0);
            transform-origin: center top;
        }
    }

    &.brasil {
        width: 73px;
        height: 48px;
    }

    &.france {
        width: 83px;
        height: 44px;
    }
}

@include mq-2 {
    a[slot='logo'] {
        width: 87px;
        height: 40px;

        &.swiss {
            width: 48px;
            height: 48px;
        }

        &.brasil {
            width: 73px;
            height: 48px;
        }

        &.france {
            width: 83px;
            height: 40px;
        }
    }
}

@include mq-1 {
    a[slot='logo'] {
        width: 69px;
        height: 32px;

        &.swiss {
            width: 40px;
            height: 40px;

            svg {
                transform: scale(2.1);
            }
        }

        &.brasil {
            width: 60px;
            height: 40px;
        }

        &.france {
            width: 67px;
            height: 32px;
        }
    }
}
